import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type OrbitLOnboardingDetailDto,
  getMerchantsPublicIDOrbitLOnboardingDetail,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const ORBIT_L_ONBOARDING_DETAIL_QUERY_KEY = "ORBIT_L_ONBOARDING_DETAIL";

export const orbitLOnboardingDetailKeys = {
  all: [ORBIT_L_ONBOARDING_DETAIL_QUERY_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...orbitLOnboardingDetailKeys.all,
    merchantPublicID,
  ],
};

export const useOrbitLOnboardingDetailQuery = (merchantPublicID?: string) =>
  useQuery<OrbitLOnboardingDetailDto>({
    queryKey: orbitLOnboardingDetailKeys.byMerchantPublicId(merchantPublicID),
    queryFn: merchantPublicID
      ? processResponseWithApiProblemDetails(() =>
          getMerchantsPublicIDOrbitLOnboardingDetail(merchantPublicID),
        )
      : skipToken,
  });
